import { createRoot } from 'react-dom/client';
import { Provider as StoreProvider, useSelector, useDispatch } from 'react-redux';
import { setTransportMode as setTransportModeRedux } from '@App/components/Map/map.slice';
import { TRANSPORT_MODES } from '@App/components/Map/controls/RouteOptions/route-options.constants';

import { faRectanglePro } from '@fortawesome/pro-solid-svg-icons';
import { Button, Icon } from '@nazka/nazka.mapframe.components';

import store from '@App/app.store';

import './route-options.styl';

function RouteOptions({ isJobCoach, forPrint }) {
  const dispatch = useDispatch();
  const transportMode = useSelector(state => state.map.transportMode);
  const setTransportMode = v => dispatch(setTransportModeRedux(v));

  return (
    <div className="route-options">
      {TRANSPORT_MODES.filter(m => (!isJobCoach ? !m.pro : isJobCoach)).map((mode) => {
        return (
          <div 
            className="route-options__option"
            data-selected={transportMode === mode.id}
            key={mode.id}
          >
            <Button
              mode={mode.id}
              title={mode.title}
              className="route-options__option__button"
              onClick={() => {
                if (!forPrint) setTransportMode(mode.id);
                window.gtag?.('event', 'map_routing_transport_type_change', {
                  event_category: 'Map',
                  event_label: 'click change routing transport type button',
                  value: mode.id,
                });
              }}
              icon={`/img/icons/transport_types/${mode.id}.svg`}
              rootElProps={{ 'data-selected': transportMode === mode.id, 'data-mode': mode.id, title: mode.title }}
              iconSize="30px"
            />
            {mode.id.includes('car') && (
              <Icon
                className="route-options__option__pro"
                icon={faRectanglePro}
              />
            )}
          </div>
        );
      })}
    </div>
  );
}

class RouteOptionsControl {
  constructor(isJobCoach, forPrint) {
    this.isJobCoach = isJobCoach;
    this.forPrint = forPrint;
  }

  onAdd(map) {
    this._map = map;
    this._container = document.createElement('div');
    this._container.className = 'maplibregl-ctrl route-options-control';
    this._root = createRoot(this._container);
    this._root.render(
      <StoreProvider store={store}>
        <RouteOptions isJobCoach={this.isJobCoach} forPrint={this.forPrint} />
      </StoreProvider>,
    );
    return this._container;
  }

  onRemove() {
    this._container?.parentNode.removeChild(this._container);
    this._map = undefined;
  }
}

export default RouteOptionsControl;
